import { useKeycloak } from '@react-keycloak/web'
import React, { useState, useEffect } from 'react'
import {
  Box,
  Tooltip,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Typography,
  ListItemIcon,
  Divider
} from '@mui/material'
import { string } from 'prop-types'
import { Settings, Logout, Lock } from '@mui/icons-material'
import theme from '../../theme/Default'

const UserProfile = ({ avatar }) => {
  const [anchorElUser, setAnchorElUser] = React.useState(null)
  const [userFunction, setUserFunction] = React.useState('')
  const [user, setUser] = useState({})
  const handleOpenUserMenu = event => {
    setAnchorElUser(event.currentTarget)
  }

  const roleList = ['admin', 'gestor', 'bibliotecario', 'leitor']

  function getMoreLevel(roles = []) {
    const aux = []
    roles.forEach(item => {
      aux[roleList.indexOf(item) - (roleList.length - roles.length)] = item
    })
    setUserFunction(aux[0])
  }

  const { keycloak } = useKeycloak()

  const handleCloseUserMenu = () => {
    setAnchorElUser(null)
  }

  useEffect(() => {
    if (keycloak.tokenParsed !== undefined) {
      setUser(keycloak.tokenParsed)
      getMoreLevel(
        keycloak?.tokenParsed?.resource_access['cometa-leitura']?.roles || []
      )
    }
  }, [user])

  return (
    <Box sx={{ flexGrow: 0 }}>
      <Tooltip title="">
        <Box className="d-flex align-center ">
          <Typography
            sx={{
              mr: 1.2,
              fontWeight: 'bold',
              color: theme.palette.leitura.contrastText
            }}
          >
            {keycloak.tokenParsed.given_name}
          </Typography>
          <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
            <Avatar
              sx={{ width: '52px', height: '52px', border: '2px solid white' }}
              src={avatar || ''}
            ></Avatar>
          </IconButton>
        </Box>
      </Tooltip>
      <Menu
        sx={{ mt: '45px' }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        <Avatar
          sx={{
            width: '120px',
            height: '120px',
            mx: 'auto',
            border: '4px solid gray'
          }}
          src={avatar || ''}
        ></Avatar>
        <Typography
          sx={{
            textAlign: 'center',
            color: theme.palette.primary.main,
            fontWeight: 'bold',
            mt: 1
          }}
        >
          {keycloak.tokenParsed?.name}
        </Typography>
        <Typography
          sx={{
            textAlign: 'center',
            textTransform: 'capitalize',
            color: theme.palette.primary.main,
            fontWeight: 'bold',
            mb: 0.5
          }}
        >
          {userFunction}
        </Typography>

        <Divider sx={{ mt: 1, mb: 2 }} />

        <MenuItem
          sx={{ minWidth: '200px' }}
          onClick={() => {
            keycloak.login({
              action: 'UPDATE_PASSWORD'
            })
          }}
        >
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Alterar Senha
        </MenuItem>
        <MenuItem
          onClick={() => {
            keycloak.logout()
            localStorage.removeItem('token')
          }}
        >
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Sair
        </MenuItem>
      </Menu>
    </Box>
  )
}
UserProfile.propTypes = {
  avatar: string
}
export default UserProfile
